import React, { useState, useEffect, useRef } from 'react';
import mainApi from '../api'; // Your main backend API (e.g., localhost:5000/api)
import otpApi from '../otpApi'; // External microservice API (https://otp.indraq.info)
import { useNavigate, Link } from 'react-router-dom';

/* --- REMOVED HARDCODED EMPLOYEES / CONFIG CHECK ---
   We now validate employeeId+email against Mongo via /auth/validate-employee
*/

const HARDCODED_CONFIG = {
  senderId: 'NEFAZO',
  templateId: '217169',
  appName: 'diwali_gift',
};
// ---

// ---------- DIWALI GROUND-SPINNER OVERLAY ----------
function ChakraSpinnerOverlay({ active, label = 'Loading…' }) {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!active) {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
      return;
    }

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { alpha: true });
    let running = true;

    const DPR = Math.max(1, window.devicePixelRatio || 1);
    function resize() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      canvas.width = Math.round(w * DPR);
      canvas.height = Math.round(h * DPR);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    // spinner params
    let t = 0;
    const center = () => ({ x: window.innerWidth / 2, y: window.innerHeight * 0.75 });
    const sparks = [];

    function draw() {
      if (!running) return;

      // soft backdrop vignette
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      const grd = ctx.createRadialGradient(
        canvas.width / (2 * DPR),
        canvas.height / (2 * DPR),
        0,
        canvas.width / (2 * DPR),
        canvas.height / (2 * DPR),
        Math.max(canvas.width, canvas.height) / DPR / 1.2
      );
      grd.addColorStop(0, 'rgba(0,0,0,0.15)');
      grd.addColorStop(1, 'rgba(0,0,0,0.55)');
      ctx.fillStyle = grd;
      ctx.fillRect(0, 0, canvas.width / DPR, canvas.height / DPR);
      ctx.restore();

      const { x, y } = center();

      // ground glow
      ctx.save();
      ctx.globalAlpha = 0.9;
      const gg = ctx.createRadialGradient(x, y + 4, 4, x, y + 4, 80);
      gg.addColorStop(0, 'rgba(255,180,80,0.45)');
      gg.addColorStop(1, 'rgba(255,180,80,0.0)');
      ctx.fillStyle = gg;
      ctx.beginPath();
      ctx.ellipse(x, y + 8, 120, 28, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();

      // chakra disc
      ctx.save();
      const rOuter = 70;
      const rInner = 18;
      const spokes = 20;
      const spin = t * 0.16; // speed
      // rim
      ctx.beginPath();
      ctx.arc(x, y, rOuter, 0, Math.PI * 2);
      ctx.lineWidth = 6;
      ctx.strokeStyle = '#ffb347';
      ctx.shadowBlur = 18;
      ctx.shadowColor = '#ffb347';
      ctx.stroke();

      // inner core
      ctx.beginPath();
      ctx.arc(x, y, rInner, 0, Math.PI * 2);
      ctx.fillStyle = '#fff5cc';
      ctx.shadowBlur = 12;
      ctx.shadowColor = '#ffe08a';
      ctx.fill();

      // colored segments
      for (let i = 0; i < spokes; i++) {
        const a0 = spin + (i / spokes) * Math.PI * 2;
        const a1 = a0 + (Math.PI * 2) / spokes * 0.6;
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.arc(x, y, rOuter - 8, a0, a1);
        ctx.closePath();
        const hue = 20 + ((i * 360) / spokes);
        ctx.fillStyle = `hsl(${hue}, 90%, 60%)`;
        ctx.globalAlpha = 0.95;
        ctx.fill();
      }
      ctx.restore();

      // center flame
      ctx.save();
      ctx.globalAlpha = 0.9 + Math.sin(t * 0.4) * 0.1;
      ctx.beginPath();
      ctx.arc(x, y, 10 + Math.sin(t * 0.7) * 2, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,220,160,0.95)';
      ctx.shadowBlur = 22;
      ctx.shadowColor = '#ffd27a';
      ctx.fill();
      ctx.restore();

      // emit sparks
      if (t % 1 < 0.6) {
        for (let i = 0; i < 12; i++) {
          const a = spin + (i / 12) * Math.PI * 2 + (Math.random() * 0.2 - 0.1);
          const s = 2.6 + Math.random() * 1.6;
          sparks.push({
            x: x + Math.cos(a) * (rOuter - 2),
            y: y + Math.sin(a) * (rOuter - 2),
            vx: Math.cos(a) * s,
            vy: Math.sin(a) * s * 0.6 - 0.2,
            life: 40 + (Math.random() * 20) | 0,
            size: 1.6 + Math.random() * 1.6,
            color: Math.random() < 0.5 ? '#ffd966' : '#fff',
          });
        }
      }

      // draw sparks
      for (let i = sparks.length - 1; i >= 0; i--) {
        const p = sparks[i];
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= 0.985;
        p.vy = p.vy * 0.985 + 0.06; // gravity
        p.life--;
        ctx.save();
        ctx.globalAlpha = Math.max(0, Math.min(1, p.life / 25)) * (0.8 + Math.random() * 0.4);
        ctx.shadowBlur = 10;
        ctx.shadowColor = p.color;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
        if (p.life <= 0) sparks.splice(i, 1);
      }

      t += 1;
      rafRef.current = requestAnimationFrame(draw);
    }

    draw();
    return () => {
      running = false;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
      window.removeEventListener('resize', resize);
    };
  }, [active]);

  if (!active) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        background: 'rgba(5,10,16,0.65)',
        backdropFilter: 'blur(3px)',
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'auto',
      }}
    >
      <canvas ref={canvasRef} style={{ display: 'block' }} />
      <div
        style={{
          position: 'fixed',
          bottom: '18vh',
          textAlign: 'center',
          color: '#ffe6b3',
          fontWeight: 700,
          letterSpacing: 0.4,
          textShadow: '0 0 18px rgba(255,200,120,.9)',
        }}
      >
        {label}
      </div>
    </div>
  );
}
// ---------------------------------------------------

// Custom Message/Popup component
const MessageBar = ({ message, type, onClose }) => {
  if (!message) return null;
  const style = {
    padding: '10px',
    margin: '10px 0',
    borderRadius: '4px',
    backgroundColor: type === 'error' ? '#f8d7da' : '#d4edda',
    color: type === 'error' ? '#721c24' : '#155724',
    border: `1px solid ${type === 'error' ? '#f5c6cb' : '#c3e6cb'}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  return (
    <div style={style}>
      <span>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>
        &times;
      </button>
    </div>
  );
};

export default function Signup() {
  const [step, setStep] = useState(1);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [profilePicture, setProfilePicture] = useState(null);
  const [otp, setOtp] = useState('');

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState('success');

  // NEW: loading overlay state
  const [loading, setLoading] = useState(false);
  const [loadingLabel, setLoadingLabel] = useState('Loading…');

  const nav = useNavigate();

  const showMessage = (msg, type = 'error') => {
    setMessage(msg);
    setMessageType(type);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      showMessage('Profile picture must be less than 2MB.', 'error');
      setProfilePicture(null);
    } else {
      setProfilePicture(file);
    }
  };

  // Step 1: Validate against allowed employees (employeeId + email), send OTP
  const sendOtp = async (e) => {
    e.preventDefault();
    showMessage(null);

    if (!profilePicture) {
      showMessage('Profile picture is mandatory.', 'error');
      return;
    }

    const inputEmployeeId = employeeId.trim();
    const inputEmail = email.trim().toLowerCase();
    const inputMobile = mobile.trim(); // user can enter any number now

    // 🔒 Validate employeeId+email via backend (Mongo allowlist)
    try {
      setLoadingLabel('Sending OTP…');
      setLoading(true);

      const resp = await mainApi.post('/auth/validate-employee', {
        employeeId: inputEmployeeId,
        email: inputEmail,
      });
      if (!resp?.data?.ok) {
        showMessage('Validation failed! Employee ID and Official Email are not allowed.', 'error');
        setLoading(false);
        return;
      }
    } catch (err) {
      showMessage(
        err.response?.data?.message || 'Validation failed! Employee ID and Official Email are not allowed.',
        'error'
      );
      setLoading(false);
      return;
    }

    // Proceed to send OTP to the provided number (no equality check)
    const phoneWithCountryCode = `+91${inputMobile}`;
    const firstName = fullName.trim().split(' ')[0] || 'User';

    try {
      await otpApi.post('/api/send-otp', {
        sender_id: HARDCODED_CONFIG.senderId,
        template_id: HARDCODED_CONFIG.templateId,
        appName: HARDCODED_CONFIG.appName,
        firstName,
        phone: phoneWithCountryCode,
      });

      showMessage(`A verification code has been sent to ${mobile}.`, 'success');
      setStep(2);
    } catch (err) {
      showMessage(
        err.response?.data?.message || 'Failed to send OTP. Check the microservice /api/send-otp endpoint.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Verify OTP and finalize signup
  const finalizeSignup = async (e) => {
    e.preventDefault();
    showMessage(null);

    const phoneWithCountryCode = `+91${mobile.trim()}`;

    // 1) Verify OTP
    try {
      setLoadingLabel('Verifying OTP…');
      setLoading(true);

      await otpApi.post('/api/verify-otp', {
        appName: HARDCODED_CONFIG.appName,
        phone: phoneWithCountryCode,
        otp: otp,
      });
    } catch (err) {
      showMessage(err.response?.data?.message || 'OTP Verification failed.', 'error');
      setLoading(false);
      return;
    }

    // 2) Finalize signup (multipart/form-data)
    const form = new FormData();
    form.append('fullName', fullName);
    form.append('email', email.trim().toLowerCase());
    form.append('password', password);
    form.append('employeeId', employeeId);
    form.append('mobile', mobile);
    if (profilePicture) form.append('profilePicture', profilePicture);

    try {
      const res = await mainApi.post('/auth/signup', form, {
        headers: { Accept: 'application/json' },
      });

      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      window.dispatchEvent(new Event('userChanged'));
      nav('/');
    } catch (err) {
      const errMsg =
        err.response?.data?.message || 'Final Signup failed. Check your network or the /auth/signup API.';
      showMessage(errMsg, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="centered">
      <h2>Signup (Employee Only)</h2>

      {/* MESSAGE BAR/POPUP */}
      <MessageBar message={message} type={messageType} onClose={() => setMessage(null)} />

      {/* STEP 1: Details Entry */}
      {step === 1 && (
        <form onSubmit={sendOtp} className="form">
          <input value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Full name" required />
          <input value={employeeId} onChange={(e) => setEmployeeId(e.target.value)} placeholder="Employee ID" required />
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Official Email"
            type="email"
            required
          />
          <input
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Mobile Number for OTP"
            type="tel"
            pattern="[0-9]{10}"
            required
          />
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            type="password"
            required
          />

          <label style={{ color: 'var(--color-text-light)', fontSize: '14px', marginTop: '5px' }}>
            Profile Picture (Mandatory)
          </label>
          <input type="file" onChange={handleFileChange} required accept="image/*" />

          <button type="submit" disabled={!profilePicture}>
            Continue & Send OTP
          </button>

          <p style={{ textAlign: 'center', marginTop: '10px' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: 'var(--color-accent)', textDecoration: 'underline', fontWeight: 'bold' }}>
              Login here
            </Link>
          </p>
        </form>
      )}

      {/* STEP 2: OTP Verification */}
      {step === 2 && (
        <form onSubmit={finalizeSignup} className="form">
          <p style={{ textAlign: 'center', color: 'var(--color-accent)' }}>Enter the code sent to **{mobile}**.</p>
          <input value={otp} onChange={(e) => setOtp(e.target.value.trim())} placeholder="Enter OTP" type="number" required />
          <button type="submit">Verify OTP & Signup</button>
          <p style={{ textAlign: 'center', marginTop: '10px', display: 'flex', padding: '0 10px', flexDirection: 'column', gap: '6px' }}>
            <button
              type="button"
              onClick={() => {
                setStep(1);
                showMessage(null);
              }}
              className="link-like"
            >
              Go Back / Edit Details
            </button>
          </p>
        </form>
      )}

      {/* Diwali chakra spinner overlay */}
      <ChakraSpinnerOverlay active={loading} label={loadingLabel} />
    </div>
  );
}
